<template>
  <div>
    <vue-select
      v-if="
        canBeDirectPayment &&
          paymentMethods.length > 0 &&
          settings &&
          settings.paymentMethod === 'stripe'
      "
      id="vs2__combobox"
      v-model="selectedPaymentMethod"
      :options="paymentMethods"
      persistent-hint
      :getOptionLabel="
        paymentMethod =>
          paymentMethod.cardLast4 !== -1
            ? `**** **** **** ${paymentMethod.cardLast4}`
            : $t('payment.addNewCard')
      "
      :clearable="false"
      :placeholder="$t('payment.selectYourCard')"
      :create-option="paymentMethod => paymentMethod"
      :reduce="paymentMethod => paymentMethod"
    ></vue-select>

    <vue-select
      v-if="
        canBeDirectPayment &&
          redsysPaymentMethods.length > 0 &&
          settings &&
          settings.paymentMethod === 'redsys'
      "
      id="vs2__combobox"
      v-model="selectedPaymentMethod"
      :options="redsysPaymentMethods"
      persistent-hint
      :getOptionLabel="
        paymentMethod =>
          paymentMethod.cardLast4 !== -1
            ? `**** **** **** ${paymentMethod.cardLast4}`
            : 'Agregar nueva tarjeta'
      "
      :clearable="false"
      placeholder="SELECCIONA TU TARJETA"
      :create-option="paymentMethod => paymentMethod"
      :reduce="paymentMethod => paymentMethod"
    ></vue-select>

    <div class="payment-buttons">
      <div
        v-if="
          !iOS() &&
            settings &&
            settings.paymentMethod === 'redsys' &&
            settings.enableGooglePay
        "
        id="container-google-pay"
      >
        <GooglePayment
          :total-price="totalPrice"
          :disable-payment-button="disablePaymentButton"
          :unpaidTotalPrice="unpaidTotalPrice"
          @checkQRUpdate="checkQRUpdate($event)"
          :tableQR="tableQR"
          :dividePayment="dividePayment"
        ></GooglePayment>
      </div>

      <div
        v-if="
          iOS() &&
            settings &&
            settings.paymentMethod === 'redsys' &&
            settings.enableApplePay
        "
        id="container-apple-pay"
      >
        <apple-pay-redsys
          :total-price="totalPrice"
          :disable-payment-button="disablePaymentButton"
          :unpaidTotalPrice="unpaidTotalPrice"
          @checkQRUpdate="checkQRUpdate($event)"
          :tableQR="tableQR"
          :dividePayment="dividePayment"
        ></apple-pay-redsys>
      </div>

      <div id="container-bizum-pay">
        <BizumPayment
          v-if="
            settings &&
              settings.paymentMethod === 'redsys' &&
              settings.enableBizum
          "
          :total-price="totalPrice"
          :disable-payment-button="disablePaymentButton"
          :unpaidTotalPrice="unpaidTotalPrice"
          :tableQR="tableQR"
          :dividePayment="dividePayment"
        ></BizumPayment>
      </div>

      <!-- Stripe Payments start -->
      <StripePayment
        v-if="settings && settings.paymentMethod === 'stripe'"
        :total-price="totalPrice"
        :disable-payment-button="disablePaymentButton"
        :drinks-collection="drinksCollection"
        :food-collection="foodCollection"
        :dessert-collection="dessertCollection"
        :cart="cart"
        :selected-payment-method="selectedPaymentMethod"
        :canBeDirectPayment="canBeDirectPayment"
        :tableQR="tableQR"
        @checkQRUpdate="checkQRUpdate($event)"
        :dividePayment="dividePayment"
      ></StripePayment>
      <!--  Stripe Payments end -->

      <!--- Redsys payment start ---->
      <RedsysPayment
        v-if="settings && settings.paymentMethod === 'redsys'"
        :total-price="totalPrice"
        :disable-payment-button="disablePaymentButton"
        :tableQR="tableQR"
        :selected-payment-method="selectedPaymentMethod"
        :canBeDirectPayment="canBeDirectPayment"
        :unpaidTotalPrice="unpaidTotalPrice"
        @checkQRUpdate="checkQRUpdate($event)"
        :dividePayment="dividePayment"
      ></RedsysPayment>
      <!--- Redsys payment end ---->
    </div>
  </div>
</template>
<script>
import StripePayment from "@/components/public/payment/stripe/StripePayment";
import GooglePayment from "@/components/public/payment/google/GooglePayment";
import BizumPayment from "@/components/public/payment/bizum/BizumPayment";
import RedsysPayment from "@/components/public/payment/redsys/RedsysPayment";
import ApplePayRedsys from "@/components/public/payment/applepay-redsys/ApplePayRedsys.vue";
import { qrCollection } from "@/collections/qrs";

export default {
  name: "paymentMethods",
  components: {
    StripePayment,
    GooglePayment,
    // eslint-disable-next-line vue/no-unused-components
    BizumPayment,
    RedsysPayment,
    ApplePayRedsys
  },
  props: [
    "disablePaymentButton",
    "drinksCollection",
    "foodCollection",
    "dessertCollection",
    "totalPrice",
    "canBeDirectPayment",
    "cart",
    "tableQR",
    "unpaidTotalPrice",
    "dividePayment"
  ],
  data() {
    return {
      qrCollection: [],
      selectedPaymentMethod: null
    };
  },
  firestore() {
    return {
      qrCollection: qrCollection.where("active", "==", true).orderBy("table")
    };
  },
  computed: {
    paymentMethods() {
      let methods =
        this.$store.state.paymentMethods &&
        this.$store.state.paymentMethods.length > 0
          ? this.$store.state.paymentMethods
          : JSON.parse(localStorage.getItem("paymentMethods"));

      methods = methods ? methods : [];
      let paymentMethods = [...methods, { cardLast4: -1 }];
      return paymentMethods.length > 1 ? paymentMethods.reverse() : [];
    },
    redsysPaymentMethods() {
      let redsysCards = this.$store.state.redsysCards;
      if (redsysCards) {
        return [...redsysCards, { cardLast4: -1 }];
      }
      return [];
    }
  },
  methods: {
    checkQRUpdate(event) {
      this.$emit("checkQRUpdate", event);
    }
  }
};
</script>
